import {
  SET_HEADER,
  SET_SUB_HEADER,
  SET_CANCELLING_LABEL,
  SET_TOOLTIP_TEXT,
  SET_SHOW_DISABLED_BTN_ERROR_MSG,
  SET_BLIND_ITEMS_ENABLED,
  SET_IS_FETCHING_ADD_CART_ITEM,
  SET_IS_FETCHING_REMOVE_CART_ITEM,
  SET_ITEMS_LAYOUT,
} from '../../actions/itemsPage';
import { ItemsLayouts } from '../../constants/enums';

export const initialState = {
  header: '',
  subheader: '',
  cancellingLabel: false,
  tooltipText: '',
  showDisabledBtnErrorMsg: false,
  blindItemsEnabled: false,
  isFetchingAddCartItem: false,
  isFetchingRemoveCartItem: false,
  itemsLayout: ItemsLayouts.ItemView,
};

export default (
  state = initialState,
  {
    type,
    data: {
      header,
      subHeader,
      cancellingLabel,
      tooltipText,
      showDisabledBtnErrorMsg,
      blindItemsEnabled,
      isFetchingAddCartItem,
      isFetchingRemoveCartItem,
      itemsLayout,
    } = {},
  } = {},
) => {
  switch (type) {
    case SET_HEADER:
      return {
        ...state,
        header,
      };
    case SET_SUB_HEADER:
      return {
        ...state,
        subHeader,
      };

    case SET_CANCELLING_LABEL:
      return {
        ...state,
        cancellingLabel,
      };

    case SET_TOOLTIP_TEXT:
      return {
        ...state,
        tooltipText,
      };

    case SET_SHOW_DISABLED_BTN_ERROR_MSG:
      return {
        ...state,
        showDisabledBtnErrorMsg,
      };

    case SET_BLIND_ITEMS_ENABLED:
      return {
        ...state,
        blindItemsEnabled,
      };

    case SET_IS_FETCHING_ADD_CART_ITEM:
      return {
        ...state,
        isFetchingAddCartItem,
      };

    case SET_IS_FETCHING_REMOVE_CART_ITEM:
      return {
        ...state,
        isFetchingRemoveCartItem,
      };

    case SET_ITEMS_LAYOUT:
      return {
        ...state,
        itemsLayout,
      };

    default:
      return state;
  }
};
